import React from "react";
import "./ParallaxSection.scss";
import parallaxBg from "../../assests/carousal-1.webp";

interface ParallaxSectionProps {
  children: React.ReactNode;
  className?: string;
  overlayOpacity?: number; // 0–1, default 0.82
  // One background image per child block. image[i] sits behind child[i].
  // Falls back to the default background if omitted, and cycles through the
  // array when there are more children than images.
  images?: string[];
}

const ParallaxSection: React.FC<ParallaxSectionProps> = ({
  children,
  className = "",
  overlayOpacity = 0.82,
  images,
}) => {
  const childArray = React.Children.toArray(children);
  const backgrounds = images && images.length > 0 ? images : [parallaxBg];

  return (
    <div className={`parallax-section ${className}`.trim()}>
      {childArray.map((child, index) => (
        <div
          className="parallax-section__band"
          key={index}
          style={{
            backgroundImage: `url(${backgrounds[index % backgrounds.length]})`,
          }}
        >
          <div
            className="parallax-section__overlay"
            style={{ "--overlay-opacity": overlayOpacity } as React.CSSProperties}
          />
          <div className="parallax-section__content">{child}</div>
        </div>
      ))}
    </div>
  );
};

export default ParallaxSection;
